@if (!hasInternetConnection) {
  <div class="connection-status tw:bg-red-600 tw:text-surface-0">{{ internetStatus }}</div>
}

<!-- begin:: Page -->
<router-outlet />
<router-outlet name="settings" />
<ngx-loading-bar
  [includeSpinner]="false"
  height="0.2rem"
  class="loading-bar" />
<!-- end:: Page -->

<!-- Chunk Not Found Dialog - Always available for error handling -->
<cor-chunk-not-found-dialog />

<!-- App Config Error Dialog - Always available for error handling -->
<cor-app-config-error-dialog />

<!-- Database Migration Modal - Always available, shows when migrations are pending -->
@if (migrationService.visible()) {
  <cor-database-migration-modal />
}

<p-confirmdialog key="confirm-dialog" />
<p-confirmpopup key="confirm-popup" />
<p-toast preventOpenDuplicates />
